//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Action from "../../action";
export default {
  props: ["spec"],
  data: function data() {
    return {
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markerPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      place: null
    };
  },
  computed: {
    placeName: function placeName() {
      return this.place == null ? "" : this.place.name;
    }
  },
  methods: {
    closeInfoWindow: function closeInfoWindow() {
      this.infoWinOpen = false;
    },
    openInfoWindow: function openInfoWindow() {
      this.infoWinOpen = true;
    },
    toggleLoadingIndicator: function toggleLoadingIndicator() {
      this.$refs.loading.classList.toggle("d-none");
      this.$refs.loading.classList.toggle("d-flex");
    },
    onActionButtonClick: function onActionButtonClick(event, properties) {
      properties.onClick["formData"] = {
        "place[google_place_id]": this.place.place_id,
        "place[name]": this.place.name,
        "place[address]": this.place.formatted_address,
        "place[longitude]": this.place.geometry.location.lng(),
        "place[latitude]": this.place.geometry.location.lat()
      };
      Action.execute(properties.onClick, this);
    },
    onMapClick: function onMapClick(e) {
      var _this = this;

      this.closeInfoWindow();

      if (e.placeId === undefined) {
        return;
      }

      e.stop();
      this.toggleLoadingIndicator();
      var request = {
        placeId: e.placeId,
        fields: ["place_id", "geometry", "name", "formatted_address"]
      };
      var service = new google.maps.places.PlacesService(this.$refs.map.$mapObject);
      service.getDetails(request, function (place) {
        _this.toggleLoadingIndicator();

        _this.markerPos = place.geometry.location;
        _this.place = place;

        _this.openInfoWindow();
      });
    },
    setLocationField: function setLocationField(name, value) {
      var field = document.querySelector("input[name=\"".concat(name, "\"]"));
      field.closest("div.v-input").classList.add("v-input--is-label-active");
      field.closest("div.v-input").classList.add("v-input--is-dirty");
      field.previousSibling.classList.add("v-label--active");
      field.value = value;
    },
    setPlace: function setPlace(place) {
      var location = place.geometry.location;
      this.place = place;
      this.markerPos = location;
      this.$refs.map.$mapObject.setCenter(location);

      if (this.spec.hasOwnProperty("locationFields")) {
        this.setLocationField(this.spec.locationFields.latitudeName, location.lat());
        this.setLocationField(this.spec.locationFields.longitudeName, location.lng());
      }
    }
  }
};